import { render, staticRenderFns } from "./results.vue?vue&type=template&id=c5a80a34"
import script from "./results.vue?vue&type=script&lang=js"
export * from "./results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MapboxMapResults: require('/vercel/path0/components/partials/MapboxMapResults.vue').default,GoogleMapResults: require('/vercel/path0/components/partials/GoogleMapResults.vue').default,AppHero: require('/vercel/path0/components/common/AppHero.vue').default,SearchBox: require('/vercel/path0/components/SearchBox.vue').default,SearchSummary: require('/vercel/path0/components/partials/SearchSummary.vue').default,Button: require('/vercel/path0/components/common/Button.vue').default,List: require('/vercel/path0/components/common/List.vue').default,AppBreadcrumb: require('/vercel/path0/components/common/AppBreadcrumb.vue').default,Timer: require('/vercel/path0/components/partials/Timer.vue').default,SortHotels: require('/vercel/path0/components/partials/SortHotels.vue').default,FilterHotels: require('/vercel/path0/components/partials/FilterHotels.vue').default,HotelResult: require('/vercel/path0/components/cards/HotelResult.vue').default,HotelResultLoader: require('/vercel/path0/components/loaders/HotelResultLoader.vue').default,ModalScreen: require('/vercel/path0/components/common/ModalScreen.vue').default})
